export var props = {
  value: {
    type: Number,
    required: true
  },
  max: {
    type: Number
  },
  min: {
    type: Number
  },
  step: {
    type: Number,
    default: 1
  },
  disabled: {
    type: Boolean,
    default: false
  },
  disabledInput: {
    type: Boolean,
    default: false
  }
};